import React from "react";

export const Marquee = () => {
  const words = [
    "Belgian Waffles",
    "Hecho con amor",
    "Crujiente por fuera",
    "Suave por dentro",
    "Premium ingredients",
    "Open daily",
    "Buffy&rsquo;s Café",
    "Dulce + Salado",
  ];
  const full = [...words, ...words, ...words];
  return (
    <div
      data-testid="marquee"
      className="relative py-6 border-y border-[#3E2723]/10 bg-[#3E2723] text-[#FFF0F3] overflow-hidden"
    >
      <div className="flex w-max animate-marquee gap-12 whitespace-nowrap">
        {full.map((w, i) => (
          <span
            key={i}
            className="font-display font-black uppercase tracking-tight text-3xl md:text-4xl flex items-center gap-12"
          >
            <span dangerouslySetInnerHTML={{ __html: w }} />
            <span className="text-[#D38C41]">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
